// "Exclusive" is the game's own rarity tier for Huge/Titanic/Gargantuan pets,
// and baby purple is that tier's real in-game color — used here as the
// primary hue instead of an invented accent-on-black scheme.
export const palettes = {
  dark: {
    bg: "#120a1a",
    surface: "#1c1029",
    surface2: "#271640",
    border: "#3a2456",
    text: "#f0e9f7",
    textDim: "#a294b8",
    accent: "#b48ee0",
    accentBright: "#d9b8ff",
  },
  light: {
    bg: "#f7f2fb",
    surface: "#ffffff",
    surface2: "#f1e8f8",
    border: "#e0cdf0",
    text: "#241631",
    textDim: "#6f5f82",
    accent: "#7c4fb0",
    accentBright: "#5e3a8c",
  },
};

export function applyPalette(isDarkMode) {
  const palette = isDarkMode ? palettes.dark : palettes.light;
  const root = document.documentElement;
  root.dataset.theme = isDarkMode ? "dark" : "light";
  Object.entries(palette).forEach(([key, value]) => {
    root.style.setProperty(`--${key}`, value);
  });
  return palette;
}
